import { render, staticRenderFns } from "./TheLoginView.vue?vue&type=template&id=97bfb0c4"
import script from "./TheLoginView.vue?vue&type=script&lang=js"
export * from "./TheLoginView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports